import { createSvgIcon } from '@mui/material/utils'

const ReportOval = createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M8 24C12.4183 24 16 20.4183 16 16C16 11.5817 12.4183 8 8 8C3.58172 8 0 11.5817 0 16C0 20.4183 3.58172 24 8 24ZM8 22.9333C11.8292 22.9333 14.9333 19.8292 14.9333 16C14.9333 12.1708 11.8292 9.06667 8 9.06667C4.17083 9.06667 1.06667 12.1708 1.06667 16C1.06667 19.8292 4.17083 22.9333 8 22.9333ZM8.53333 11.2V17.6H7.46667V11.2H8.53333ZM8.53333 20.8V19.7333H7.46667V20.8H8.53333Z"
    fill="#455065"
  />,
  'ReportOval'
)

export default ReportOval
